import { render, staticRenderFns } from "./Secenekler.vue?vue&type=template&id=5a430802&scoped=true&"
import script from "./Secenekler.vue?vue&type=script&lang=js&"
export * from "./Secenekler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a430802",
  null
  
)

export default component.exports